import { ProjectViewModel } from "../../ViewModel/ProjectViewModel";

export const updateSpdrFTLIdentifier = (project: ProjectViewModel) => {
  project.SpdrsOnThisProject?.forEach((spdrOnProjectItem) => {
    spdrOnProjectItem.UsedInFtlRoutes = 0;
  });

  project.FTLRoutes?.forEach((ftlRouteItem) => {
    if (ftlRouteItem.IsExpired) {
      return;
    }
    ftlRouteItem.SpdrsOnThisRoute?.forEach((spdrOnThisRouteItem) => {
      const index = project.SpdrsOnThisProject?.findIndex(
        (x) =>
          x.SupplierGsdb === spdrOnThisRouteItem.SupplierGsdb &&
          x.PlantGsdb === spdrOnThisRouteItem.PlantGsdb &&
          x.DockCode === spdrOnThisRouteItem.DockCode
      );
      project.SpdrsOnThisProject![index as number].UsedInFtlRoutes! += 1;
    });
  });
  return project;
};
